import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { acfText } from "../../utils/landingAcf";
import {
  LANDING_WHATSAPP_CONTEXT,
  resolveLandingWhatsAppCta,
} from "../../utils/landingWhatsapp";
import SectionLoader from "../common/SectionLoader";
import "../common/HeroSection.css";
import "./LandingHero.css";

function LandingHero({ acf, heroImageUrl, loading = false }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <section className="landing-hero landing-hero--loading hero-slide hero-slide--page" aria-busy="true">
        <div className="hero-color-overlay hero-color-overlay--deep absolute inset-0" aria-hidden="true" />
        <div className="landing-hero__inner hero-inner hero-inner--page relative z-10">
          <SectionLoader size="lg" label={t("Loading section")} className="landing-hero__loader" />
        </div>
      </section>
    );
  }

  const title = acfText(acf.hero_title);
  const description = acfText(acf.hero_description);
  const ctaText = acfText(acf.hero_cta_text);
  const ctaLink = resolveLandingWhatsAppCta(t, LANDING_WHATSAPP_CONTEXT.HERO, {
    label: ctaText || t("landing.whatsapp.defaultAction"),
  });

  if (!title && !description) return null;

  return (
    <section className="landing-hero hero-slide hero-slide--page" aria-label={title}>
      {heroImageUrl ? (
        <div
          className="hero-bg-image landing-hero__bg absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImageUrl})` }}
          aria-hidden="true"
        />
      ) : null}
      <div className="hero-color-overlay hero-color-overlay--deep absolute inset-0" aria-hidden="true" />
      <div className="hero-page-gradient absolute inset-0" aria-hidden="true" />
      <div className="hero-vignette absolute inset-0" aria-hidden="true" />

      <div className="landing-hero__inner hero-inner hero-inner--page relative z-10">
        <div className="hero-text-panel landing-hero__panel hero-text-panel--page">
          <div className="landing-hero__head">
            <span className="hero-page-eyebrow">CAF SPORTS</span>
            <div className="hero-title-accent hero-title-accent--page landing-hero__accent" aria-hidden="true" />
          </div>

          {title ? <h1 className="hero-copy hero-page-title landing-hero__title">{title}</h1> : null}

          {description ? (
            <p className="hero-copy hero-page-subtitle landing-hero__description">{description}</p>
          ) : null}

          {ctaText ? (
            <div className="hero-cta-row landing-hero__cta">
              <a
                href={ctaLink.href}
                className="hero-btn hero-btn--primary"
                target={ctaLink.target}
                rel={ctaLink.rel}
              >
                <span className="hero-btn__label">{ctaText}</span>
                <span className="hero-btn__icon-wrap" aria-hidden="true">
                  <FaArrowLeft className="hero-btn__icon" />
                </span>
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default LandingHero;
